import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './style.module.scss'

interface Props {
  content?: React.ReactNode
  open: boolean
  scroll?: boolean
  handleClose?: () => void
  onClick?: () => void
}

const ModalWrapper = ({ content, open, scroll, handleClose }: Props) => {
  return (
    <Modal
      disablePortal={scroll}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      id="Modal"
      open={open}
      onClose={handleClose}
    >
      <div>
        <div className={styles.paper}>{content}</div>
      </div>
    </Modal>
  )
}
export default ModalWrapper
